import * as _ from 'lodash';
import React, { FormEvent } from 'react';
import { IListItem } from '@nkr/models/index';
import { Button, ControlLabel, FormControl, FormGroup, HelpBlock, Panel } from 'react-bootstrap';
import { ContactPanelBodyWrapper } from '../styles';
import { IContactForEdit } from './contact-for-edit';
import { IValidation } from './validation';

interface IProps {
    data: IContactForEdit,
    validation: IValidation,
    phoneTypes: IListItem[],
    positionList: IListItem[],
    onAddEditChange: (data: IContactForEdit) => void,
    onSave: () => void,
    onCancel: () => void
}

const OpoContactAddEdit: React.FC<IProps> = ({ data, validation, phoneTypes, positionList, onAddEditChange, onSave, onCancel }) => {
    const handleTextChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let property = e.currentTarget.id;
        let value = e.currentTarget.value;

        let newEdit = _.cloneDeep(data);

        if (property == 'firstName') {
            newEdit.firstName = value;
        }

        if (property == 'lastName') {
            newEdit.lastName = value;
        }

        if (property == 'email') {
            newEdit.email = value;
        }

        onAddEditChange(newEdit);
    };

    return (
        <Panel style={{ marginBottom: 0 }}>
            <Panel.Heading>{data.id > 0 ? 'Edit OPO Contact' : 'Add OPO Contact'}</Panel.Heading>

            <ContactPanelBodyWrapper>
                <FormGroup validationState={!validation.firstName ? 'error' : null}>
                    <ControlLabel>First Name</ControlLabel>
                    <FormControl
                        id='firstName'
                        value={data.firstName}
                        onChange={handleTextChange}
                    />

                    {!validation.firstName && (
                        <HelpBlock>First name is required</HelpBlock>
                    )}
                </FormGroup>

                <FormGroup validationState={!validation.lastName ? 'error' : null}>
                    <ControlLabel>Last Name</ControlLabel>
                    <FormControl
                        id='lastName'
                        value={data.lastName}
                        onChange={handleTextChange}
                    />

                    {!validation.firstName && (
                        <HelpBlock>Last name is required</HelpBlock>
                    )}
                </FormGroup>

                <FormGroup validationState={!validation.email ? 'error' : null}>
                    <ControlLabel>Email Address</ControlLabel>
                    <FormControl
                        id='email'
                        value={data.email}
                        onChange={handleTextChange}
                    />

                    {!validation.email && (
                        <HelpBlock>Email address is required</HelpBlock>
                    )}
                </FormGroup>
            </ContactPanelBodyWrapper>

            <Panel.Footer style={{ textAlign: 'center', paddingTop: 5, paddingBottom: 5 }}>
                <Button bsStyle='primary' onClick={onSave}>Save</Button>{' '}
                <Button onClick={onCancel}>Cancel</Button>
            </Panel.Footer>
        </Panel>
    );
}

export default OpoContactAddEdit;